import { Icon } from '@blueprintjs/core';
import { SITE_ICON, SITE_PAGES, SITE_TITLE } from 'Config';
import ConditionalWrapper from 'Lib/hoc/ConditionalWrapper';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router';
import styles from './BOSHomeButton.module.css';

const BOSHomeButton = ({
  showText = true,
  large = false,
  disableLink = false,
  minimal = false,
}) => {
  return (
    <ConditionalWrapper
      wrapper={(children) => (
        <NavLink
          className={styles.link}
          to={SITE_PAGES.HOME.to || ''}
          onMouseDown={(e) => e.preventDefault()}>
          {children}
        </NavLink>
      )}
      condition={!disableLink}>
      <div
        className={
          minimal ? styles.icon_container_minimal : styles.icon_container
        }>
        {!minimal && (
          <Icon
            className={styles.site_icon}
            icon={SITE_ICON}
            size={large ? 68 : 30}
          />
        )}
        {showText && !minimal && (
          <span className={large ? styles.site_title_large : styles.site_title}>
            {SITE_TITLE}
          </span>
        )}
      </div>
    </ConditionalWrapper>
  );
};

BOSHomeButton.propTypes = {
  showText: PropTypes.bool,
  large: PropTypes.bool,
  disableLink: PropTypes.bool,
  minimal: PropTypes.bool,
};

export default BOSHomeButton;
